import { validationMessages } from './validationMessages.schema';

export default {
  title: 'Faktura',
  type: 'object',
  properties: {
    group: {
      computed: true,
      title: 'Wyszukiwanie po: numer faktury, NIP wystawcy, kwota faktury / rachunku',
      type: 'string'
    },
    invoicesInGroup: {
      computed: true,
      items: {
        type: 'object',
        properties: {
          id: { type: 'int' },
          schol: { type: 'string' },
          documentId: { type: 'int' },
          priceToPay: { type: 'money' }
        }
      },
      type: 'array'
    },

    nip: {
      fieldRequired: true,
      format: 'nip',
      readOnly: ['return !!(this.group && this.invoicesInGroup && this.invoicesInGroup.length)'],
      title: 'NIP wystawcy',
      type: 'string',
      validFunc: ['if (!$value || !/^\\d+$/.test($value)) {', '  return "Błąd: Nieprawidłowy numer NIP.";', '}'],
      validationMessages: {
        format: 'Błąd: Nieprawidłowy numer NIP.'
      }
    },

    date: {
      fieldRequired: true,
      format: 'date',
      readOnly: ['return !!(this.group && this.invoicesInGroup && this.invoicesInGroup.length)'],
      title: 'Data wystawienia',
      type: 'string',
      validationMessages: {
        validFunc: 'Data faktury musi pokrywać się z okresami wypłat na podstawie faktur.'
      },
      validFunc: [
        'if (',
        '  !$external.document ||',
        '  !$external.document.currentDecision ||',
        '  !$external.document.currentDecision.dateRanges ||',
        '  !$external.document.currentDecision.dateRanges.length',
        ') {',
        '  return true;',
        '}',
        'var momentDate = $methods.moment($value);',
        'return $external.document.currentDecision.dateRanges',
        '  .map((range, index, ranges) =>',
        '    Object.assign({}, range, {',
        '      endDate:',
        '        range.endDate ||',
        '        (ranges[index + 1] && ranges[index + 1].endDate) ||',
        '        $external.document.currentDecision.endDate',
        '    })',
        '  )',
        '  .filter(range => range.type === "INVOICE")',
        '  .some(range => momentDate.isSameOrAfter(range.startDate) && momentDate.isSameOrBefore(range.endDate));'
      ]
    },

    number: {
      fieldRequired: true,
      readOnly: ['return !!(this.group && this.invoicesInGroup && this.invoicesInGroup.length)'],
      title: 'Numer faktury',
      type: 'string',
      validFunc: [
        'if (!this.number || !this.date || !this.nip) {',
        '  return true;',
        '}',
        'for (var invoice of $external.otherInvoices) {',
        '  if (invoice.number === this.number && invoice.date === this.date && invoice.nip === this.nip) {',
        '    return "Błąd: Została już wprowadzona faktura o tych samych danych.";',
        '  }',
        '}',
        'return true;'
      ]
    },

    price: {
      fieldRequired: true,
      minimum: 0.01,
      readOnly: ['return !!(this.group && this.invoicesInGroup && this.invoicesInGroup.length)'],
      title: 'Kwota faktury',
      type: 'number',
      validationMessages: {
        minimum: 'Kwota musi być większa od 0 zł.'
      }
    },

    priceToPay: {
      title: 'Kwota zakwalifikowana do refundacji z faktury',
      type: 'money',
      fieldRequired: true,
      maximum: [
        'if(!(this.invoicesInGroup && this.invoicesInGroup.length)){',
        '  return this.price;',
        '}',
        'var invoicesSum = this.invoicesInGroup.reduce((sum, invoice) => sum + invoice.priceToPay, 0);',
        'var maximum = this.price - invoicesSum;',
        'return $methods.mround(maximum);'
      ],
      minimum: 0.01,
      warnings: {
        maximum: '$methods.mround($external.maxToPay)',
        warningMessages: {
          maximum: 'Uwaga. Przekroczono przyznaną kwotę stypendium.'
        }
      },
      validationMessages: {
        maximum: 'Uwaga. Z faktury do wykorzystania pozostało {{maximum}} zł.',
        minimum: 'Kwota musi być większa od 0 zł.'
      }
    },

    mdokUid: {
      length: 100,
      title: 'UID dokumentu MDOK',
      type: 'string'
    },

    description: {
      length: 1000,
      title: 'Uwagi (należy wpisać numer pozycji lub nazwę asortymentu z faktury)',
      type: 'string',
      fieldRequired: true,
      validationMessages: {
        required: 'Uwaga. Pole obowiązkowe.'
      }
    }
  },
  allOf: [validationMessages]
};
